import { render, staticRenderFns } from "./right_fin.vue?vue&type=template&id=82541dca&scoped=true&"
import script from "./right_fin.vue?vue&type=script&lang=js&"
export * from "./right_fin.vue?vue&type=script&lang=js&"
import style0 from "./right_fin.vue?vue&type=style&index=0&id=82541dca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82541dca",
  null
  
)

export default component.exports